/* eslint-disable import/no-default-export */
import { Icon, IconColor, IconName } from 'app/common/components/controls';
import { forNamespace } from 'app/common/lib/util/i18n';
import * as React from 'react';
import styles from './out-of-free-team-boards.less';

const format = forNamespace('out of free team boards', {
  shouldEscapeStrings: false,
});

const OutOfFreeTeamBoards = () => {
  const text = {
    title: format('this team has reached the maximum number of open boards'),
    summary: format('upgrade to business class and get'),
    unlimitedTeamBoards: format('unlimited team boards'),
    powerfulAdminTools: format('powerful admin tools'),
    unlimitedPowerUps: format('unlimited power-ups'),
    collectionsToOrganizeBoards: format('collections to organize boards'),
    butlerBot: format('workflow automation with butler'),
  };

  return (
    <div className={styles.ooftbContainer}>
      <div className={styles.ooftbText}>
        <div className={styles.title}>{text.title}</div>
        <p>{text.summary}</p>
        <ul>
          <li>
            <Icon name={IconName.Board} color={IconColor.Blue} />{' '}
            <span className={styles.liText}>{text.unlimitedTeamBoards}</span>
          </li>
          <li>
            <Icon name={IconName.Admin} color={IconColor.Green} />{' '}
            <span className={styles.liText}>{text.powerfulAdminTools}</span>
          </li>
          <li>
            <Icon name={IconName.Collection} color={IconColor.Purple} />{' '}
            <span className={styles.liText}>
              {text.collectionsToOrganizeBoards}
            </span>
          </li>
          <li>
            <Icon name={IconName.PowerUp} color={IconColor.Pink} />{' '}
            <span className={styles.liText}>{text.unlimitedPowerUps}</span>
          </li>
          <li>
            <Icon name={IconName.ButlerBot} color={IconColor.Dark} />{' '}
            <span className={styles.liText}>{text.butlerBot}</span>
          </li>
        </ul>
        <div className={styles.learnMoreLinkContainer}>
          <a
            className={styles.learnMoreLink}
            href="https://help.trello.com/article/1177-personal-vs-team-boards"
            target="_blank"
            rel="noopener noreferrer"
          >
            {format('learn more')}
          </a>
        </div>
      </div>
    </div>
  );
};

export default OutOfFreeTeamBoards;
